const initialState = () => ({
    list: []
});

const formsReducer = (state = initialState(), action) => {
    const newState = Object.assign({}, state);
    switch (action.type) {
        case 'FORMS_RECEIVED':
            newState.list = action.payload;
            return newState;
        case 'LOGOUT':
            return Object.assign({}, initialState());
        default:
            return state;
    }
};

export default formsReducer;


